// extracted by mini-css-extract-plugin
export default {"noTemplateAvailable":"NoAvailableTemplate_noTemplateAvailable__K8NxV","button":"NoAvailableTemplate_button__8-+2J","hint":"NoAvailableTemplate_hint__UVs7p"};